import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import { MdSync } from "react-icons/md";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css"

const GrnDsInfonew = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [currentDate, setCurrentDate] = useState("");
    const [isLatestData, setIsLatestData] = useState(true); // Track if showing latest data
    const [highlightedDates, setHighlightedDates] = useState([]);

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    const columnWithDefs = [
        { 
            headerName: "Item SKU", 
            field: "item_sku", 
            sortable: true,
            filter: true
        },
        { 
            headerName: "Item Type Name", 
            field: "item_type_name", 
            sortable: true,
            filter: true
        },
        { 
            headerName: "Destination Store ID", 
            field: "destination_store_id", 
            sortable: true,
            filter: true
        },
        { 
            headerName: "Destination Store Name", 
            field: "destination_store_name", 
            sortable: true,
            filter: true
        },
        { 
            headerName: "Vendor SKU Code", 
            field: "vendor_sku_code", 
            sortable: true,
            filter: true
        },
        { 
            headerName: "Quantity", 
            field: "quantity", 
            sortable: true,
            filter: true

        },
        { 
            headerName: "Facility Code", 
            field: "facility_code", 
            sortable: true,
            filter: true
        },  
        { 
            headerName: "Inflow Receipt Code", 
            field: "inflow_receipt_code", 
            sortable: true,
            filter: true
        },
           { 
            headerName: "Purchase Order Code", 
            field: "purchase_order_code", 
            sortable: true,
            filter: true
        },
         {
            headerName: "Date", 
            field: "date", 
            sortable: true,
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return date.toISOString().split('T')[0];
            },
            width: "160px"
        },
        {
            headerName: "Inserted Date", 
            field: "inserted_date", 
            sortable: true,
            hide: true,
            filter: "agDateColumnFilter",
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return date.toISOString().split('T')[0];
            },
            width: "160px"
        }
    ];

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    }

    const defaultColDef = {
        sortable: true,
        minWidth: 150,
        filter: true,
        pivot: true,
        enableValue: true,
        enableRowGroup: true,
        resizable: true,
    }

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        if (gridColumnApi.current) {
            const allColumns = gridColumnApi.current.getAllColumns();
            if (allColumns && allColumns.length > 0) {
                const allColumnIds = allColumns.map(col => col.getColId());
                gridColumnApi.current.autoSizeColumns(allColumnIds, false);
            }
        }
    };

    const onFirstDataRendered = (params) => {
        if (gridColumnApi.current) {
            const allColumns = gridColumnApi.current.getAllColumns();
            if (allColumns && allColumns.length > 0) {
                const allColumnIds = allColumns.map(col => col.getColId());
                gridColumnApi.current.autoSizeColumns(allColumnIds, false);
            }
        }
    };

    const triggerUserAction = (trigerdata) => {
        redirectURL.post('inventory/triggerUserAction', trigerdata) 
    }

    const onApplygetGrnDsInfoDatanew = async (selectedDate = null) => {
        try {
            setLoadshow("show-m")
            setOverlayBlock("show-m");
            
            const params = {};
            if (selectedDate) {
                params.date = selectedDate;
                setIsLatestData(false); // Not showing latest data when specific date is selected
            } else {
                setIsLatestData(true); // Showing latest data when no date specified
            }
            
            const response = await redirectURL.post("indentation/getGrnDsInfoDatanew", params);

            if (response.data && response.data.status === 'success') {
                const grnData = response.data.data.grn_data;
                const latestDate = response.data.data.latest_inserted_date || '';
                
                setRowData(grnData);
                
                // Set the current date only if we're showing latest data or have a selected date
                if (selectedDate) {
                    setCurrentDate(selectedDate);
                } else if (latestDate) {
                    setCurrentDate(latestDate);
                }
                
                setLoadshow("show-n");
                setOverlayBlock("show-n");

                // Show message if no data available for the selected date
                if (selectedDate && grnData.length === 0) {
                    setBasicTitle(`No data available for selected date: ${selectedDate}`);
                    setBasicType("info");
                    setShow(true);
                }
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setBasicTitle("Failed to fetch GRN data");
                setBasicType("error");
                setShow(true);
            }
        } catch (error) {
            console.error("Error fetching GRN DS Info data:", error);
            setBasicTitle("Failed to fetch GRN DS Info data");
            setBasicType("error");
            setShow(true);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

          const getHighlightedDates = async () => {
        try {
            const response = await redirectURL.post("indentation/getGRNAvailableDates", {});
            if (response.status === 200 && response.data.dates) {
            const dates = response.data.dates.map(dateStr => {
                try {
                return new Date(dateStr);
                } catch (e) {
                return null;
                }
            }).filter(date => date !== null);
            setHighlightedDates(dates);
            }
        } catch (error) {
            console.error("Failed to fetch highlighted dates:", error);
        }
        }
     const getGrnDsInfoDatanew = async (selectedDate = null) => {
        try {
            setLoadshow("show-m")
            setOverlayBlock("show-m");
            
            const params = {first: "true"};
            if (selectedDate) {
                params.date = selectedDate;
                setIsLatestData(false); // Not showing latest data when specific date is selected
                await getHighlightedDates();
            } else {
                setIsLatestData(true); // Showing latest data when no date specified
            }
            
            const response = await redirectURL.post("indentation/getGrnDsInfoDatanew", params);

            if (response.data && response.data.status === 'success') {
                const grnData = response.data.data.grn_data;
                const latestDate = response.data.data.latest_inserted_date || '';
                
                setRowData(grnData);
                
                // Set the current date only if we're showing latest data or have a selected date
                if (selectedDate) {
                    setCurrentDate(selectedDate);
                } else if (latestDate) {
                    setCurrentDate(latestDate);
                }
                
                setLoadshow("show-n");
                setOverlayBlock("show-n");

                // Show message if no data available for the selected date
                if (selectedDate && grnData.length === 0) {
                    setBasicTitle(`No data available for selected date: ${selectedDate}`);
                    setBasicType("info");
                    setShow(true);
                }
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setBasicTitle("Failed to fetch GRN data");
                setBasicType("error");
                setShow(true);
            }
        } catch (error) {
            console.error("Error fetching GRN DS Info data:", error);
            setBasicTitle("Failed to fetch GRN DS Info data");
            setBasicType("error");
            setShow(true);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const getFilteredData = async () => {
        await getGrnDsInfoDatanew(currentDate);
    };

    const handlefetchGRNDatanewnew = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const response = await redirectURL.post("indentation/fetchGRNDatanew");

            if (response.data.status === "success") {
                // After fetching new data, reload with latest date
                await getGrnDsInfoDatanew(); // This will fetch latest date data
                setShow(true);
                setBasicType("success");
                const userData = {
                    email: localStorage.getItem("email"),
                    user_code: localStorage.getItem("user_code"),
                    action: "Fetch GRN Data",
                    status: "Success",
                    path: window.location.pathname
                };
                triggerUserAction(userData);
                setBasicTitle("GRN data fetched successfully.");
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
                setShow(true);
                setBasicType("info");
                setBasicTitle("No GRN data found.");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to fetch GRN data.";
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            setShow(true);
            setBasicType("error");
            const userData = {
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Failed to Fetch GRN Data",
                status: "Error",
                path: window.location.pathname
            };
            triggerUserAction(userData);
            setBasicTitle(errorMessage);
        }
    };

    const closeAlert = () => {
        setShow(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };
  const applyFilters = async () => {
        await onApplygetGrnDsInfoDatanew(currentDate);
    };

    const resetFilters = () => {
        // Clear date filter to show latest data
        setCurrentDate("");
        setIsLatestData(true);
        // Fetch latest data (no date filter)
        getGrnDsInfoDatanew();
    };

    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = date.toISOString().split('T')[0];
            setCurrentDate(formattedDate);
        } else {
            setCurrentDate("");
        }
    };

    const showLatestData = () => {
        setCurrentDate("");
        setIsLatestData(true);
        getGrnDsInfoDatanew();
    };

    useEffect(() => {
        // Load latest date data by default on component mount
        getGrnDsInfoDatanew();
        getHighlightedDates()
    }, []);

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>    
                    <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div className="col-sm-8 row">
                            {/* Date Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                                <label
                                    htmlFor="insertedDate"
                                    style={{ fontSize: "13px", fontWeight: "400" }}
                                >
                                    Date:
                                </label>
                                <DatePicker
                                    selected={currentDate ? new Date(currentDate) : null}
                                    onChange={handleDateChange}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    highlightDates={highlightedDates}
                                    placeholderText="Select date or leave empty for latest"
                                    style={{
                                        padding: "7px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        width: "100%",
                                        marginBottom: "15px",
                                        cursor: "pointer"
                                    }}
                                />
                            </div>

                            <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); applyFilters(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { 
                                        e.preventDefault(); 
                                        resetFilters();
                                    }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        {/* Fetch GRN Data Button */}
                        <div className="col-sm-4" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                onClick={(e) => { e.preventDefault(); handlefetchGRNDatanewnew(); }}
                                className="add-button upload-add-button fetch-stn"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#fff",
                                    color: "#93385D",
                                    borderRadius: "5px",
                                    padding: "8px 16px",
                                    border: "1px solid #93385D",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: "500"
                                }}
                            >
                                <MdSync style={{ color: "#93385D", fontSize: "18px" }} />
                                <span style={{ marginLeft: "6px" }}>Fetch GRN Data</span>
                            </button>
                        </div>
                    </form>

                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                suppressHorizontalScroll={false}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                pagination={true}
                                paginationPageSize={1000}
                                enableRangeSelection={true}
                                gridOptions={{
                                    suppressHorizontalScroll: false
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
        </>
    );
};

export default GrnDsInfonew;